module.exports = __webpack_public_path__ + "static/media/gsb-iconSurvey.af0538fc.svg";